import { Feed, FeedContent, FeedEvent, FeedExtra, FeedSummary, Segment, SegmentGroup } from "semantic-ui-react"

const BifrostSegment = ({ segmentList, bottomSegment }) => {
	return (
		<SegmentGroup style={{ marginTop: "0px" }}>
			<SegmentGroup horizontal>
				{segmentList.map((segment, index) => (
					<Segment style={{ width: "50%" }} key={index}>
						{segment.map(
							(feed) =>
								(feed.renderCondition == null || feed.renderCondition == true) && (
									<Feed key={feed.key}>
										<FeedEvent className="device-event-margin">
											{feed.label && <Feed.Label image={feed.label} />}
											{feed.content && (
												<FeedContent>
													{feed.data && <Feed.Date content={feed.data} />}
													<FeedSummary content={feed.feedName} />
													{feed.content.label && <FeedExtra text className={feed.content.className} content={feed.content.label} />}
													{feed.content.modal}
												</FeedContent>
											)}
											{feed.component && feed.component}
										</FeedEvent>
									</Feed>
								)
						)}
					</Segment>
				))}
			</SegmentGroup>
			{bottomSegment && bottomSegment}
		</SegmentGroup>
	)
}

BifrostSegment.propTypes = {}

export default BifrostSegment
